import React, { useRef, useEffect, useState } from "react";
import { forwardRef } from "react";
import { Link } from "react-router-dom";
import { FaEnvelope, FaHandshake, FaLinkedin } from "react-icons/fa";
import { PopupButton } from "react-calendly";

const Contact = forwardRef(function Contact({}, refContact) {
  return (
    <div
      className="page flex flex-col items-center justify-center min-h-screen px-6 md:px-20 py-10"
    >
      <h1
        className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-[#00df9a] to-emerald-400 drop-shadow-lg mb-8 md:mb-12"
        ref={refContact}
      >
        Contact
      </h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-4xl">
        <a
          href="https://calendly.com/mirceamartinioan"
          className="bg-white/5 hover:bg-white/10 border border-white/10 backdrop-blur-md rounded-3xl p-6 flex items-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-blue-500/20 group md:col-span-2 md:mx-auto md:w-3/4"
        >
          <div className="bg-gradient-to-br from-blue-400 to-blue-600 p-4 rounded-2xl group-hover:scale-110 transition-transform duration-300 shadow-lg">
            <FaHandshake size={32} className="text-white" />
          </div>
          <div className="ml-6 flex flex-col justify-center text-left">
            <h3 className="text-lg font-bold text-white mb-1">Meeting</h3>
            <div className="text-gray-300 font-medium">
              <PopupButton
                url="https://calendly.com/mirceamartinioan"
                rootElement={document.getElementById("root")}
                text="Schedule on Calendly"
                className="hover:text-blue-400 transition-colors"
              />
            </div>
          </div>
        </a>

        <a href="https://www.linkedin.com/in/mirchm" className="bg-white/5 hover:bg-white/10 border border-white/10 backdrop-blur-md rounded-3xl p-6 flex items-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-blue-600/20 group">
          <div className="bg-gradient-to-br from-blue-500 to-blue-700 p-4 rounded-2xl group-hover:scale-110 transition-transform duration-300 shadow-lg">
            <FaLinkedin size={32} className="text-white" />
          </div>
          <div className="ml-6 flex flex-col justify-center">
            <h3 className="text-lg font-bold text-white mb-1">LinkedIn</h3>
            <p className="text-gray-300 font-medium">linkedin.com/in/mirchm</p>
          </div>
        </a>

        <a href="mailto:mirceamartinioan@gmail.com" className="bg-white/5 hover:bg-white/10 border border-white/10 backdrop-blur-md rounded-3xl p-6 flex items-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl hover:shadow-red-500/20 group">
          <div className="bg-gradient-to-br from-red-400 to-red-600 p-4 rounded-2xl group-hover:scale-110 transition-transform duration-300 shadow-lg">
            <FaEnvelope size={32} className="text-white" />
          </div>
          <div className="ml-6 flex flex-col justify-center">
            <h3 className="text-lg font-bold text-white mb-1">Email</h3>
            <p className="text-gray-300 font-medium">mirceamartinioan@gmail.com</p>
          </div>
        </a>
      </div>
      
      <div className="mt-16 flex flex-col md:flex-row gap-4 justify-center items-center">
        <Link to="/apple-developer" className="inline-flex items-center space-x-2 bg-white/10 hover:bg-white/20 border border-white/20 rounded-full px-6 py-3 transition-all duration-300">
          <span className="text-white font-bold">View Apple Developer Contact</span>
          <span className="text-white">&rarr;</span>
        </Link>
        <Link to="/rofuel-privacy" className="inline-flex items-center space-x-2 bg-white/10 hover:bg-white/20 border border-white/20 rounded-full px-6 py-3 transition-all duration-300">
          <span className="text-white font-bold">RoFuel Privacy Policy</span>
          <span className="text-white">&rarr;</span>
        </Link>
      </div>
    </div>
  );
});

export default Contact;
